<section class="py-3 py-md-5">
    <div class="container">
        <div class="row justify-content-md-center">
            <div class="col-12 col-md-10 col-lg-8 col-xl-7 col-xxl-6">
                <h2 class="mb-4 display-5 contact-page-text-color text-center">Contact Us</h2>
                <p class=" mb-5 contact-page-text-color text-center">The best way to contact us is to use our contact
                    form below.
                    Please fill out all of the required fields and we will get back to you as soon as possible.</p>
            </div>
        </div>
    </div>

    <div class="container">
        <div class="row justify-content-lg-center">
            <div class="col-12 col-lg-9">
                <div class="border rounded shadow-sm overflow-hidden">

                    <form [formGroup]="contactForm" (ngSubmit)="contactData(contactForm.value)">
                        <div class="row gy-4 gy-xl-5 p-4 p-xl-5">
                            <div class="col-12">
                                <label for="fullname" class="form-label contact-page-text-color">Username <span
                                        class="text-danger">*</span></label>
                                <input type="text" formControlName="username" class="form-control" id="fullname"
                                    name="fullname" value="" required>
                            </div>
                
                            <div class="col-12">
                                <label for="message" class="form-label contact-page-text-color">subject <span
                                        class="text-danger">*</span></label>
                                <input type="text" formControlName="subject" class="form-control" id="subject"
                                    name="subject" value="" required>

                            </div>
                            <div class="col-12">
                                <label for="message" class="form-label contact-page-text-color">feedback <span
                                        class="text-danger">*</span></label>
                                <textarea class="form-control" formControlName="feedback" id="feedback" name="feedback"
                                    rows="3" required></textarea>
                            </div>
                            <div class="col-12">
                                <div class="d-grid">
                                    <button class="btn btn-primary btn-lg" type="submit">Submit</button>
                                </div>
                            </div>
                        </div>
                    </form>

                </div>
            </div>
        </div>
    </div>
</section>




  